var exports = {
  "kL": "xa15a2ab7--b24b57--container",
  "Kk": "xa15a2ab7--b24b57--icon",
  "lY": "xa15a2ab7--b24b57--popup",
  "TU": "xa15a2ab7--b24b57--popup--open",
  "Fp": "xa15a2ab7--b24b57--link-container",
  "nf": "xa15a2ab7--b24b57--link",
};

module.exports = exports;
